<div [class.opened]="isModalOpen()" class="homework-item">
    <div (click)="clickHomework(homework)"
         (keydown.enter)="clickHomework(homework)"
         (keydown.space)="$event.preventDefault(); clickHomework(homework)"
         class="homework-content"
         [attr.data-bs-target]="'#link-' +homework.link"
         data-bs-toggle="modal"
         tabindex="0"
         role="button"
    >
        <span class="homework-title">{{ title }}</span>
    </div>

    <div class="dropdown-element">
        @if (applicationStateService.userData.isTeacher) {
            <div class="dropdown">
                <button
                    class="btn btn-link p-0 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-offset="20, 5"
                    type="button"
                >
                    <i class="fas fa-angle-down statistic"></i>
                </button>
                <ul class="dropdown-menu">
                    <li class="dropdown-item">
                        <button (click)="clickHomework(homework)">
                            <i class="fas fa-link"></i>Abgabelink anzeigen
                        </button>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li class="dropdown-item"><a class="d-block" [href]="homework.getLink()" target="_blank"><i class="fas fa-external-link-square"></i>Aufgabe öffnen</a></li>
                    <li class="big-divider"></li>
                    <li class="dropdown-item"><a class="d-block" [href]="downloadLink" target="_blank"><i class="fas fa-analytics"></i>Auswertung anzeigen</a></li>
                    @if (!foreign) {
                        <li><hr class="dropdown-divider"></li>
                        <li class="dropdown-item red">
                            <button (click)="deleteHomework(homework)">
                                <i class="fas fa-times"></i>Aufgabe entfernen
                            </button>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</div>
